export class Certificate {
  public title: string = '';
  public resumeId: string = '';
  public id: string = ''
}
